import { styled } from '@linaria/react';

function ColorBox({ color, label }) {
  return (
    <BoxWrapper>
      <Box style={{ backgroundColor: color }} />
      <Label>{label}</Label>
    </BoxWrapper>
  );
}

function LCHColors({}) {
  return (
    <Wrapper>
      <ColorBox
        color="rgb(56.08% 52.16% 0%)"
        label={
          <>
            lch(<Lit>55%</Lit> 132 95)
          </>
        }
      />
      <ColorBox
        color="rgb(28.77% 50.04% 100%)"
        label={
          <>
            lch(<Lit>55%</Lit> 132 280)
          </>
        }
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  padding: 0 32px;
  justify-content: center;
  width: 100%;
`;

const BoxWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 212px;
  width: 250px;
  max-width: 250px;
`;

const Box = styled.div`
  width: 100%;
  min-height: 40px;
  aspect-ratio: 1 / 1;
  border-radius: 6px;
`;

const Label = styled.div`
  text-align: center;
  font-family: var(--font-family-mono);
  padding: 0px 8px;
`;

const Lit = styled.span`
  font-weight: var(--font-weight-bold);
  color: var(--color-success);
`;

export default LCHColors;
